// extracted by mini-css-extract-plugin
module.exports = {"List_Scroll_Table":"PartnersList_List_Scroll_Table__gawE6"};